import { render, staticRenderFns } from "./drillSideView.vue?vue&type=template&id=0b8c2b01"
import script from "./drillSideView.js?vue&type=script&lang=js&external"
export * from "./drillSideView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports